export default "__VITE_ASSET__GRGky5Q4__"